// extracted by mini-css-extract-plugin
module.exports = {"icon":"Error_icon__6yRUQ"};